import 'babel-polyfill'
import 'typeface-muli';
import React from 'react';
import ReactDOM from 'react-dom';
import history from './history';
import './react-table-defaults';
import './styles/index.css';
import JssProvider from 'react-jss/lib/JssProvider';
import {create} from 'jss';
import {createGenerateClassName, jssPreset} from '@material-ui/core/styles';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';
import {routes} from './fuse-configs/fuseRoutesConfig';
import {FuseLayout, FuseTheme, FuseAuthorization} from '@fuse';
import MainToolbar from './main/MainToolbar';
import MainNavbarContent from './main/MainNavbarContent';
import MainNavbarHeader from './main/MainNavbarHeader';
import MainFooter from './main/MainFooter';
import jssExtend from 'jss-extend'
import QuickPanel from 'main/quickPanel/QuickPanel';
import store from 'store';
import {Auth} from 'auth';
import './appConfig';

const jss = create({
    ...jssPreset(),
    plugins: [...jssPreset().plugins, jssExtend()]
});

jss.options.insertionPoint = document.getElementById('jss-insertion-point');
const generateClassName = createGenerateClassName();

// fetch(localStorage.getItem('api_domain')+'/api/AuthPengguna?token='+localStorage.getItem('jwt_token'),{
//     method: 'GET'
// })
// .then(res => res.json())
// .then(
// (result) => {

    // if(result.status === 'Token is Expired' || result.status === 'Authorization Token not found'){
    if((localStorage.getItem('user') === '' || localStorage.getItem('user') === null) && (localStorage.getItem('jwt_token') === '' || localStorage.getItem('jwt_token') === null)){
        localStorage.setItem('jwt_token', '');
        localStorage.setItem('user', '');
        // localStorage.setItem('baru_registrasi', 1);

        if(window.location.href.search('login') === -1){

            let split1 = window.location.href.split("?")[1];
            let split3 = null;
            
            if(typeof(split1) !== 'undefined'){
                let split2 = split1.split("&")[0];

                if(typeof(split2) !== 'undefined'){
                    split3 = split2.split("=")[1];
                }
            }

            if(!split3){
                if(Number(localStorage.getItem('tipe_app')) === 3){
                    window.location.href = 'login/index.html';
                }else{
                    window.location.href = 'login';
                }
            }else{
                window.location.href = 'login?code='+split3;
            }
            // return true;
            
        }

        ReactDOM.render(
            <JssProvider jss={jss} generateClassName={generateClassName}>
            
                <Provider store={store}>
                    <Auth>
                        <Router history={history}>
                            <FuseAuthorization routes={routes}>
                                <FuseTheme>
                                    <FuseLayout
                                        routes={routes}
                                        toolbar={
                                            <MainToolbar/>
                                        }
                                        navbarHeader={
                                            <MainNavbarHeader/>
                                        }
                                        navbarContent={
                                            <MainNavbarContent/>
                                        }
                                        footer={
                                            <MainFooter/>
                                        }
                                        rightSidePanel={
                                            <React.Fragment>
                                                <QuickPanel/>
                                            </React.Fragment>
                                        }
                                    >
                                    </FuseLayout>
                                </FuseTheme>
                            </FuseAuthorization>
                        </Router>
                    </Auth>
                </Provider>
            </JssProvider>
            , document.getElementById('root'));
    }else{

        // if(Number(localStorage.getItem('tipe_app')) === 1 && Number(localStorage.getItem('online')) === 1){

        //     console.log( window.location.href.split("?")[1].split("&")[0].split("=")[1] );

        //     if((localStorage.getItem('access_token') == null || localStorage.getItem('access_token') == '') && window.location.href.split("?")[1].split("&")[0].split("=")[1]){
        //         fetch(localStorage.getItem('api_domain')+'/api/getTokenSSO?code='+window.location.href.split("?")[1].split("&")[0].split("=")[1],{
        //         // fetch('https://id.hub.kemdikbud.go.id/sso/token',{
        //             method: 'post'
        //         })
        //         .then(res => res.json())
        //         .then(
        //         (result) => {
        //             // console.log(result.error);
        //             if(typeof(result.access_token) !== 'undefined'){
        //                 localStorage.setItem('access_token', result.access_token);
        //                 localStorage.setItem('refresh_token', result.refresh_token);

        //                 fetch(localStorage.getItem('api_domain')+'/api/getProfileSSO?access_token='+localStorage.getItem('access_token'),{
        //                     method: 'post'
        //                 })
        //                 .then(res => res.json())
        //                 .then(
        //                 (result) => {
        //                     // console.log(JSON.stringify(result));
        //                     localStorage.setItem('user', JSON.stringify(result));
        //                 });
        //             }
        //         });
        //     }else if(window.location.href.split("?")[1].split("&")[0].split("=")[1]){
        //         fetch(localStorage.getItem('api_domain')+'/api/getProfileSSO?access_token='+localStorage.getItem('access_token'),{
        //             method: 'post'
        //         })
        //         .then(res => res.json())
        //         .then(
        //         (result) => {
        //             // console.log(JSON.stringify(result));
        //             localStorage.setItem('user', JSON.stringify(result));
        //         });
        //     }

        // }
        // if(typeof(result.user) !== 'undefined'){

        //     if(result.user.peran_id === 13){
        //         if(localStorage.getItem('sekolah_id_pengawas') !== null || localStorage.getItem('sekolah_id_pengawas') !== ''){
        //             result.user.sekolah_id = localStorage.getItem('sekolah_id_pengawas');
        //             localStorage.setItem('user', JSON.stringify(result.user));
        //         }else{
        //             localStorage.setItem('user', JSON.stringify(result.user));
        //         }
        //     }else{
        //         localStorage.setItem('user', JSON.stringify(result.user));
        //     }
        
        // fetch(localStorage.getItem('api_domain')+'/api/AuthPengguna?token='+localStorage.getItem('jwt_token'),{
        //     method: 'GET'
        // })
        // .then(res => res.json())
        // .then(
        // (result) => {

        // });
    
            ReactDOM.render(
                <JssProvider jss={jss} generateClassName={generateClassName}>
                    <Provider store={store}>
                        <Auth>
                            <Router history={history}>
                                <FuseAuthorization routes={routes}>
                                    <FuseTheme>
                                        <FuseLayout
                                            routes={routes}
                                            toolbar={
                                                <MainToolbar/>
                                            }
                                            navbarHeader={
                                                <MainNavbarHeader/>
                                            }
                                            navbarContent={
                                                <MainNavbarContent/>
                                            }
                                            footer={
                                                <MainFooter/>
                                            }
                                            rightSidePanel={
                                                <React.Fragment>
                                                    <QuickPanel/>
                                                </React.Fragment>
                                            }
                                        >
                                        </FuseLayout>
                                    </FuseTheme>
                                </FuseAuthorization>
                            </Router>
                        </Auth>
                    </Provider>
                </JssProvider>
                , document.getElementById('root'));
        // }else{
        //     ReactDOM.render(
        //         <JssProvider jss={jss} generateClassName={generateClassName}>
                
        //             <Provider store={store}>
        //                 <Auth>
        //                     <Router history={history}>
        //                         <FuseAuthorization routes={routes}>
        //                             <FuseTheme>
        //                                 <FuseLayout
        //                                     routes={routes}
        //                                     toolbar={
        //                                         <MainToolbar/>
        //                                     }
        //                                     navbarHeader={
        //                                         <MainNavbarHeader/>
        //                                     }
        //                                     navbarContent={
        //                                         <MainNavbarContent/>
        //                                     }
        //                                     footer={
        //                                         <MainFooter/>
        //                                     }
        //                                     rightSidePanel={
        //                                         <React.Fragment>
        //                                             <QuickPanel/>
        //                                         </React.Fragment>
        //                                     }
        //                                 >
        //                                 </FuseLayout>
        //                             </FuseTheme>
        //                         </FuseAuthorization>
        //                     </Router>
        //                 </Auth>
        //             </Provider>
        //         </JssProvider>
        //         , document.getElementById('root'));
        // }
    }
// })

if(localStorage.getItem('tipe_app') !== '3'){
    registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.js